import { IEmailMap } from './blade';

const TIME_LINE: any = {
    us: {
        teaser: '2023/05/18 16:00:00 GMT+8',
        detail: '2023/05/25 23:30:00 GMT+8',
    },
    ca: {
        teaser: '2023/05/18 16:00:00 GMT+8',
        detail: '2023/05/25 23:30:00 GMT+8',
    },
    eu: {
        teaser: '2023/05/25 23:30:00 GMT+8',
        detail: '2023/05/31 15:00:00 GMT+8',
    },
    uk: {
        teaser: '2023/05/25 23:30:00 GMT+8',
        detail: '2023/05/31 15:00:00 GMT+8',
    },
    de: {
        teaser: '2023/05/25 23:30:00 GMT+8',
        detail: '2023/05/31 15:00:00 GMT+8',
    },
    fr: {
        teaser: '2023/05/25 23:30:00 GMT+8',
        detail: '2023/05/31 15:00:00 GMT+8',
    },
    it: {
        teaser: '2023/05/25 23:30:00 GMT+8',
        detail: '2023/05/31 15:00:00 GMT+8',
    },
    es: {
        teaser: '2023/05/25 23:30:00 GMT+8',
        detail: '2023/05/31 15:00:00 GMT+8',
    },
    jp: {
        teaser: '2023/05/19 10:00:00 GMT+8',
        crowdfunding: '2023/05/25 10:00:00 GMT+8',
        detail: '2023/06/30 23:00:00 GMT+8',
    },
    cn: {
        detail: '2023/06/09 17:00:00 GMT+8',
    },
    au: {
        teaser: '2024/01/25 09:00:00 GMT+8',
        detail: '2024/02/01 09:00:00 GMT+8',
    },
    za: {
        teaser: '2024/04/09 15:00:00 GMT+8',
        detail: '2024/04/15 15:00:00 GMT+8',
    },
    tw: {
        detail: '2024/04/23 09:00:00 GMT+8',
    },
    sa: {
        detail: '2024/04/23 09:00:00 GMT+8',
    },
};

const TIME_LINE_TEST: any = {
    us: {
        teaser: '2024/04/19 16:00:00 GMT+8',
        detail: '2024/05/26 15:00:00 GMT+8',
    },
    ca: {
        teaser: '2023/04/19 16:00:00 GMT+8',
        detail: '2023/05/26 15:00:00 GMT+8',
    },
    eu: {
        teaser: '2024/04/19 16:00:00 GMT+8',
        detail: '2024/05/26 15:00:00 GMT+8',
    },
    ph: {
        teaser: '2024/04/19 16:00:00 GMT+8',
        detail: '2024/05/26 15:00:00 GMT+8',
    },
    uk: {
        teaser: '2023/04/19 16:00:00 GMT+8',
        detail: '2023/05/26 15:00:00 GMT+8',
    },
    de: {
        teaser: '2023/04/19 16:00:00 GMT+8',
        detail: '2023/05/26 15:00:00 GMT+8',
    },
    fr: {
        teaser: '2023/04/19 16:00:00 GMT+8',
        detail: '2023/05/26 15:00:00 GMT+8',
    },
    it: {
        teaser: '2023/04/19 16:00:00 GMT+8',
        detail: '2023/05/26 15:00:00 GMT+8',
    },
    es: {
        teaser: '2023/04/19 16:00:00 GMT+8',
        detail: '2023/05/26 15:00:00 GMT+8',
    },
    jp: {
        teaser: '2023/04/19 10:00:00 GMT+8',
        crowdfunding: '2023/04/25 10:00:00 GMT+8',
        detail: '2023/06/29 16:00:00:00 GMT+8',
    },
    cn: {
        detail: '2023/05/09 17:00:00 GMT+8',
    },
    au: {
        teaser: '2024/01/25 09:00:00 GMT+8',
        detail: '2024/02/01 09:00:00 GMT+8',
    },
    za: {
        teaser: '2024/01/25 09:00:00 GMT+8',
        detail: '2024/05/01 09:00:00 GMT+8',
    },
    tw: {
        detail: '2024/03/23 09:00:00 GMT+8',
    },
    sa: {
        detail: '2024/03/23 09:00:00 GMT+8',
    },
};

export const getDelta2MaxTimeLine = (locale: string, flag?: boolean) =>
    flag ? TIME_LINE_TEST[locale] || TIME_LINE_TEST.us : TIME_LINE[locale] || TIME_LINE.us;

export enum STAGES {
    UNKNOWN,
    TEASER,
    CROWDFUNDING,
    DETAIL,
}

export interface Delta2MaxProps {
    stage: STAGES;
    productDetail?: any;
    resProductCatagory?: any;
    supportData?: any;
    crowdfundingTimeline?: any;
    nowSysTime?: any;
}

export const emailMap: IEmailMap = {
    us: {
        type: 'klaviyo',
        list_id: 'WzRrPj',
        source: 'EcoFlow DELTA 2 Max Teaser from',
        consent_form_id: 'YeNyL6',
        popupBtnLink: 'https://bit.ly/42JJIiG',
    },
    ca: {
        type: 'klaviyo',
        list_id: 'VFSS5g',
        source: 'EcoFlow DELTA 2 Max Teaser from',
        consent_form_id: 'S9Dmfb',
        popupBtnLink: 'https://bit.ly/42JJIiG',
    },
    eu: {
        type: 'klaviyo',
        list_id: 'QNJfJ8',
        source: 'EcoFlow DELTA 2 Max Teaser from',
        consent_form_id: 'Ymz5kv',
        popupBtnLink: '/register?redirect=/delta-2-max-portable-power-station',
    },
    uk: {
        type: 'klaviyo',
        list_id: 'VVQTy6',
        source: 'EcoFlow DELTA 2 Max Teaser from',
        consent_form_id: 'StjnDY',
        popupBtnLink: '/register?redirect=/delta-2-max-portable-power-station',
    },
    de: {
        type: 'klaviyo',
        list_id: 'Sr58u2',
        source: 'EcoFlow DELTA 2 Max Teaser from',
        consent_form_id: 'VQEnNc',
        popupBtnLink: '/register?redirect=/delta-2-max-portable-power-station',
    },
    fr: {
        type: 'klaviyo',
        list_id: 'Wdx96a',
        source: 'EcoFlow DELTA 2 Max Teaser from',
        consent_form_id: 'T94abU',
        popupBtnLink: '/register?redirect=/delta-2-max-portable-power-station',
    },
    it: {
        type: 'klaviyo',
        list_id: 'QRFeES',
        source: 'EcoFlow DELTA 2 Max Teaser from',
        consent_form_id: 'W5Gnvx',
        popupBtnLink: '/register?redirect=/delta-2-max-portable-power-station',
    },
    es: {
        type: 'klaviyo',
        list_id: 'VJQCn6',
        source: 'EcoFlow DELTA 2 Max Teaser from',
        consent_form_id: 'SYSERq',
        popupBtnLink: '/register?redirect=/delta-2-max-portable-power-station',
    },
    jp: {
        type: 'mailchimp',
        action: 'https://ecoflow.us8.list-manage.com/subscribe/post?u=d002bf04842356c4c1c5221cf&amp;id=450c1ec0e9&amp;f_id=00bb72e1f0',
        popupBtnLink: '/',
    },
    au: {
        type: 'klaviyo',
        list_id: 'TygtR9',
        source: 'EcoFlow DELTA 2 Max Teaser from',
        consent_form_id: 'WDGGNE',
        popupBtnLink: '/register?redirect=/delta-2-max-portable-power-station',
    },
};

// KV模块youtube链接
export const youtubeMap: any = {
    us: 'https://www.youtube.com/embed/dee5PAhIijo',
    ca: 'https://www.youtube.com/embed/dee5PAhIijo',
    eu: 'https://www.youtube.com/embed/R05l8eojOKw',
    uk: 'https://www.youtube.com/embed/R05l8eojOKw',
    de: 'https://www.youtube.com/embed/XVtPR0M8ozA',
    fr: 'https://www.youtube.com/embed/-aAeKjsl2gU',
    it: 'https://www.youtube.com/embed/RdG4jtMmHi4',
    es: 'https://www.youtube.com/embed/t4_XN97Ijz0',
    jp: 'https://www.youtube.com/embed/4UGldDkxFQw',
    cn: {
        SD: 'https://videos.ecoflow.com/554361e0fed271eda2514700b5ba0102/cd9a1a4a21aa427da23f521fd2e02129-2c014d8ba1a70e64853afaef252ae207-ld.mp4',
        HD: 'https://videos.ecoflow.com/554361e0fed271eda2514700b5ba0102/cd9a1a4a21aa427da23f521fd2e02129-80e328bf5db24bf5f3a59ff928f784dd-sd.mp4',
        '2K': 'https://videos.ecoflow.com/554361e0fed271eda2514700b5ba0102/cd9a1a4a21aa427da23f521fd2e02129-1fc4ec11a9c779bf6643ff556983f95f-hd.mp4',
    },
    za: 'https://www.youtube.com/embed/R05l8eojOKw', // 复制eu
    tw: 'https://www.youtube.com/embed/dee5PAhIijo', // 复制us
    sa: 'https://www.youtube.com/embed/R05l8eojOKw', // 复制uk
};

export const ACTIVITY_MAP: any = {
    jp: 40,
};

export const getTCDelta2max = (locale: string) => {
    const map: any = {
        jp: {
            title: 'crowdfunding.header.terms.title_delta2max',
            desc: 'crowdfunding.header.terms.desc_delta2max',
            links: [
                'mailto:support.jp@ecoflow.com',
                'https://jp.ecoflow.com/pages/warranty-policy',
                'https://jp.ecoflow.com/pages/online-store-policy',
                // 'https://jp.ecoflow.com/pages/price-guarantee',
                // 'mailto:hello.jp@ecoflow.com',
            ],
        },
    };
    return map[locale] || map.jp;
};

export const getTeaserYoutubeMap = (locale: string) => {
    const map: any = {
        us: [
            'https://www.youtube.com/embed/R05l8eojOKw',
            'https://www.youtube.com/embed/H3molIVAL38',
            'https://www.youtube.com/embed/0ztZu9EDhd8',
            'https://www.youtube.com/embed/040RYK7Qu7Q',
            'https://www.youtube.com/embed/qJ6nDf4LliE',
        ],
    };
    return map[locale] || map.us;
};

export const buyNowMap: any = {
    us: 'https://ecoflow-tech.myshopify.com/cart/40540239593545:1?channel=buy_button&discount=2X110WSPFREE',
    ca: 'https://ca.ecoflow.com/products/delta-2-max-portable-power-station',
};
